import { Grid } from '@material-ui/core';
import React from 'react';

import { FineKinneyHazardDamageDefinitionDto } from 'api/client';
import { updateFirmFineKinneyHazardDamageDefinitionUpdate } from 'api/hs/risk-fineKinney';
import BaseDefinitionForm from 'Common/BaseDefinitionForm';
import TextField from 'Common/Form/TextField';

interface Props {
  open: boolean;
  data: FineKinneyHazardDamageDefinitionDto;

  onClose(success: boolean): void;
}

export default function FineKinneyDamageDefinitionForm({ open, onClose, data }: Props) {
  return (
    <BaseDefinitionForm<FineKinneyHazardDamageDefinitionDto>
      open={open}
      onClose={onClose}
      onUpdate={updateFirmFineKinneyHazardDamageDefinitionUpdate}
      data={data}
      createTitle="Fine-Kinney Şiddet Ekleme"
      updateTitle="Fine-Kinney Şiddet Düzenleme"
      maxDialogWidth={500}>
      <Grid item lg={12} md={12}>
        <TextField required name="label" label="İsmi" />
      </Grid>
      <Grid item lg={12} md={12}>
        <TextField required name="value" label="Değeri" />
      </Grid>
    </BaseDefinitionForm>
  );
}
